<template>
    <div class="file-wrapper-multi-view-button">
        <Tooltip
            :disabled="!isBeta"
            :visibleArrow="false"
            :openDelay="200"
            :content="$t('fileWrapperMultiView.betaTips')"
            popperClass="file-wrapper-multi-view-button__tooltip"
            effect="light"
            placement="top"
        >
            <button
                class="th-btn th-btn-text pa-px-[24px]"
                @click="triggerMultiView(true)"
            >
                <span>{{ $t('fileWrapperMultiView.amendmentHistory') }}</span>
                <span v-if="isBeta" class="beta">{{ $t('fileWrapperMultiView.beta') }}</span>
            </button>
        </Tooltip>
        <transition name="multi-view-show">
            <FileWrapperMultiView
                v-if="showFileWrapperMultiView"
                :patentId="patentId"
                @close="triggerMultiView(false)"
            />
        </transition>
    </div>
</template>

<script setup lang="ts">
import FileWrapperMultiView from './FileWrapperMultiView.vue';
import { ref, defineProps } from 'vue';
import { Tooltip } from 'element-ui';


defineProps({
    patentId: {
        type: String,
        required: true,
    },
    isBeta: {
        type: Boolean,
        default: false,
    },
});

const showFileWrapperMultiView = ref(false);
const triggerMultiView = (val: boolean) => {
    showFileWrapperMultiView.value = val;
};

</script>


<style lang="scss">
.file-wrapper-multi-view-button {
    display: inline-block;

    .beta {
        display: inline-block;
        line-height: 20px;
        background: $status-blue-light;
        color: $status-blue-primary;
        margin-left: 4px;
        padding: 0 4px;
        border-radius: 4px;
        font-size: 12px;
    }

    .multi-view-show-enter {
        opacity: 0;
        transform: scale(0.2);
    }

    .multi-view-show-enter-active {
        transition: all 0.5s;
    }

    .multi-view-show-enter-to {
        opacity: 1;
        transform: scale(1);
    }

    .multi-view-show-leave {
        opacity: 1;
        transform: scale(1);
    }

    .multi-view-show-leave-active {
        transition: all 0.5s;
    }

    .multi-view-show-leave-to {
        opacity: 0;
        transform: scale(0.2);
    }
}
.file-wrapper-multi-view-button__tooltip {
    &.el-tooltip__popper.is-light {
        border: 1px solid $border-light;
        padding: 8px;
        color: $text-primary;
        box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    }
}
</style>
